// extracted by mini-css-extract-plugin
export default {"ContactWrapper":"Contact_ContactWrapper__6l3ty","LinkedInWrapper":"Contact_LinkedInWrapper__fE6c2"};